import $ from 'jquery';
import Selectize from 'selectize';

/* eslint-disable camelcase, one-var */

// Selectize's utility function used in the overwritten deleteSelection method
const getSelection = function (input) {
    const result = {};
    if ('selectionStart' in input) {
        result.start = input.selectionStart;
        result.length = input.selectionEnd - result.start;
    } else if (document.selection) {
        input.focus();
        const sel = document.selection.createRange();
        const selLen = document.selection.createRange().text.length;
        sel.moveStart('character', -input.value.length);
        result.start = sel.text.length - selLen;
        result.length = selLen;
    }
    return result;
};

Selectize.define('multiple_select_items_wrap', function (options) {
    const self = this;
    const KEY_BACKSPACE = 8;

    options = $.extend({
        className: 'selectize-items-wrap'
    }, options);

    /**
     * Immediately apply the following changes:
     * - Extending:
     * -    Setup method
     * - Overwriting:
     * -    insertAtCaret
     * -    selectAll
     * -    deleteSelection
     * -    setCaret
     * -    getItem
     * -    advanceSelection
     *
     * Almost all methods stay as they are in the Selectize itself.
     *
     * The main point is to change the wrapper which selection items are added in.
     * Selectize puts everything in $control where $control_input lives.
     * This is changed to $itemsWrap. So selection items and $control_input are separated from each other.
     **/
    (function () {
        self.setup = (() => {
            const original = self.setup;

            return function () {
                original.apply(self, arguments);
                // Create an additional wrapper for items
                // and prepend it to $control
                self.$itemsWrap = $(`<div class=${options.className}>`).prependTo(self.$control);
            };
        })();

        self.insertAtCaret = function ($el) {
            const caret = Math.min(self.caretPos, self.items.length);

            self.$itemsWrap.prepend($el);

            self.setCaret(caret + 1);
        };

        self.selectAll = function () {

            if (self.settings.mode === 'single') {
                return;
            }

            self.$activeItems = Array.prototype.slice.apply(self.$itemsWrap.children().addClass('active'));
            if (self.$activeItems.length) {
                self.hideInput();
                self.close();
            }
            self.focus();
        };

        self.deleteSelection = function (e) {
            let i, n, direction, selection, values, caret, option_select, $option_select, $tail;

            direction = (e && e.keyCode === KEY_BACKSPACE) ? -1 : 1;
            // selection = getSelection(self.$control_input[0]);
            selection = self.$control_input[0];
            if (self.$activeOption && !self.settings.hideSelected) {
                option_select = self.getAdjacentOption(self.$activeOption, -1).attr('data-value');
            }

            // determine items that will be removed
            values = [];

            if (self.$activeItems.length) {
                $tail = self.$itemsWrap.children(`.active:${ direction > 0 ? 'last' : 'first'}`);
                caret = self.$itemsWrap.children().index($tail);
                if (direction > 0) {
                    caret++;
                }

                for (i = 0, n = self.$activeItems.length; i < n; i++) {
                    values.push($(self.$activeItems[i]).attr('data-value'));
                }
                if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            } else if ((self.isFocused || self.settings.mode === 'single') && self.items.length) {
                if (direction < 0 && selection.start === 0 && selection.length === 0) {
                    values.push(self.items[self.caretPos - 1]);
                } else if (direction > 0 && selection.start === self.$control_input.val().length) {
                    values.push(self.items[self.caretPos]);
                }
            }

            // allow the callback to abort
            if (!values.length || (typeof self.settings.onDelete === 'function' && self.settings.onDelete.apply(self, [values]) === false)) {
                return false;
            }

            // perform removal
            if (typeof caret !== 'undefined') {
                self.setCaret(caret);
            }
            while (values.length) {
                self.removeItem(values.pop());
            }

            self.showInput();
            self.positionDropdown();
            self.refreshOptions(true);

            // select previous option
            if (option_select) {
                $option_select = self.getOption(option_select);
                if ($option_select.length) {
                    self.setActiveOption($option_select);
                }
            }

            return true;
        };

        self.setCaret = function (i) {
            let caret = i;

            if (self.settings.mode === 'single') {
                caret = self.items.length;
            } else {
                caret = Math.max(0, Math.min(self.items.length, caret));
            }

            if (!self.isPending) {
                // the input must be moved by leaving it in place and moving the
                // siblings, due to the fact that focus cannot be restored once lost
                // on mobile webkit devices
                let j, n, $children, $child;
                $children = self.$itemsWrap.children();
                for (j = $children.length - 1, n = 0; j >= n; j--) {
                    $child = $($children[j]).detach();
                    self.$itemsWrap.prepend($child);
                }
            }

            self.caretPos = caret;
        };

        self.getItem = function (value) {
            return self.getElementWithValue(value, self.$itemsWrap.children());
        };

        self.advanceSelection = function (direction, e) {
            let tail, selection, idx, valueLength, cursorAtEdge, $tail;

            if (direction === 0) {
                return;
            }

            if (self.rtl) {
                direction *= -1;
            }

            tail = direction > 0 ? 'last' : 'first';
            // selection = getSelection(self.$control_input[0]);
            selection = self.$control_input[0];

            if (self.isFocused && !self.isInputHidden) {
                valueLength = self.$control_input.val().length;
                cursorAtEdge = direction < 0
                    ? selection.start === 0 && selection.length === 0
                    : selection.start === valueLength;

                if (cursorAtEdge && !valueLength) {
                    self.advanceCaret(direction, e);
                }
            } else {
                $tail = self.$itemsWrap.children(`.active:${tail}`);
                if ($tail.length) {
                    idx = self.$itemsWrap.children().index($tail);
                    self.setActiveItem(null);
                    self.setCaret(direction > 0 ? idx + 1 : idx);
                }
            }
        };
    })();

    this.reRenderItemsWrap = function () {
        self.$itemsWrap = $(`<div class=${options.className}>`).prependTo(self.$control);
    };
});
